<template>
  <form ref="editarForm" @submit.prevent="submitIncluirForm">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.tipo_imovel"
                inputId="tipo_imovel"
                :options="tipoImovel"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
                :invalid="campoVazio.includes('tipo_imovel')"
            />
            <label for="tipo_imovel">
              <strong>Tipo Imóvel:</strong> <span class="text-danger font-bold">*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-9">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="descricao" v-model="dado.descricao" size="small" style="width: 100%"
                       :invalid="campoVazio.includes('descricao')"/>
            <label for="descricao"><strong>Descrição: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <InputGroup size="small">
            <FloatLabel variant="on">
              <InputMask id="cep" v-model="dado.cep" size="small" style="width: 100%" mask="99999-999"
                         :invalid="campoVazio.includes('cep')"/>
              <label for="cep"><strong>CEP: <span class="text-danger font-bold">*</span></strong></label>
            </FloatLabel>
            <InputGroupAddon>
              <Button icon="pi pi-search" severity="secondary" variant="text" size="small" @click="cepClick"/>
            </InputGroupAddon>
          </InputGroup>
        </div>
      </div>
      <div class="col-md-7">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="endereco" v-model="dado.endereco" size="small" style="width: 100%"
                       :invalid="campoVazio.includes('endereco')"/>
            <label for="endereco"><strong>Endereço: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="numero" v-model="dado.numero" size="small" style="width: 100%"
                       :invalid="campoVazio.includes('numero')"/>
            <label for="numero"><strong>Número: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="complemento" v-model="dado.complemento" size="small" style="width: 100%"/>
            <label for="complemento"><strong>Complemento: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="bairro" v-model="dado.bairro" size="small" style="width: 100%"
                       :invalid="campoVazio.includes('bairro')"/>
            <label for="bairro"><strong>Bairro: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="cidade" v-model="dado.cidade" size="small" style="width: 100%"
                       :invalid="campoVazio.includes('cidade')"/>
            <label for="cidade"><strong>Cidade: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-1">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="uf" v-model="dado.uf" size="small" style="width: 100%"
                       :invalid="campoVazio.includes('uf')"/>
            <label for="uf"><strong>UF: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputNumber id="valor" v-model="dado.valor" size="small" style="width: 100%"
                         :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"
                         :invalid="campoVazio.includes('valor')"/>
            <label for="valor"><strong>Valor: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <DatePicker id="data_previsao_entrega" v-model="dado.data_previsao_entrega" showIcon iconDisplay="input"
                        size="small" style="width: 100%" appendTo="body" ref="previsaoEntrega" dateFormat="dd/mm/yyyy"/>
            <label for="data_previsao_entrega"><strong>Previsão de entrega: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <DatePicker id="habita_se" v-model="dado.habita_se" showIcon iconDisplay="input"
                        size="small" style="width: 100%" appendTo="body" ref="habitaSe" dateFormat="dd/mm/yyyy"/>
            <label for="habita_se"><strong>Data Habite-se: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <DatePicker id="entrega_chaves" v-model="dado.entrega_chaves" showIcon iconDisplay="input"
                        size="small" style="width: 100%" appendTo="body" ref="entregaChaves" dateFormat="dd/mm/yyyy"/>
            <label for="entrega_chaves"><strong>Data Chaves: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <FloatLabel variant="on">
            <Textarea id="observacao" v-model="dado.observacao" rows="2" cols="110"/>
            <label for="observacao"><strong>Observação: </strong></label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.numero_quartos"
                inputId="numero_quartos"
                :options="numeroQuartos"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
            />
            <label for="numero_quartos">
              <strong>Nº Quartos:</strong>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.numero_banheiros"
                inputId="numero_banheiros"
                :options="numeroBanheiros"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
            />
            <label for="numero_banheiros">
              <strong>Nº Banheiros:</strong>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.numero_vagas"
                inputId="numero_vagas"
                :options="numeroVagas"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
            />
            <label for="numero_vagas">
              <strong>Nº Vagas:</strong>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputNumber id="valor_condominio" v-model="dado.valor_condominio" size="small" style="width: 100%"
                         :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
            <label for="valor_condominio"><strong>Valor Condomínio: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputNumber id="m2" v-model="dado.m2" size="small" style="width: 100%"
                         :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"
                         :invalid="campoVazio.includes('m2')"/>
            <label for="m2"><strong>M2: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.status"
                inputId="status"
                :options="status"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
                :invalid="campoVazio.includes('status')"
            />
            <label for="status">
              <strong>Status: <span class="text-danger font-bold">*</span></strong>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <FloatLabel variant="on">
            <Textarea id="descritivo" v-model="dado.descritivo" rows="4" cols="110"/>
            <label for="descritivo"><strong>Descritivo: </strong></label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <div class="ibox-footer">
      <div class="float-right">
        <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
      </div>
      <button class="btn btn-danger font-bold" @click="$emit('fechar')">
        Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import {buscarCep} from '../../../public/js/api/buscar_cep';
import {apiUrl} from "@/router/apiBackRoutes";
import {denormalizeDates, normalizeDates} from "../../../public/js/utils/funcoes";


export default {
  nome: 'EditarImovel',
  props: {
    imovelId: Number,
    imovelKey: String,
  },
  emits: ["fechar", "atualizarImovel"],
  data() {
    return {
      dado: {},
      erro: null,
      campoVazio: [],
      tipoImovel: [
        {label: 'CONSTRUIDO', value: 'C'},
        {label: 'NA PLANTA', value: 'N'}
      ],
      status: [
        {label: 'Disponível', value: 'D'},
        {label: 'Em Análise', value: 'E'},
        {label: 'Vendido', value: 'V'},
      ],
      numeroQuartos: [
        {label: '0', value: '0'},
        {label: '1', value: '1'},
        {label: '2', value: '2'},
        {label: '3', value: '3'},
        {label: '4', value: '4'},
        {label: '5+', value: '5'}
      ],
      numeroBanheiros: [
        {label: '0', value: '0'},
        {label: '1', value: '1'},
        {label: '2', value: '2'},
        {label: '3', value: '3'},
        {label: '4', value: '4'},
        {label: '5+', value: '5'}
      ],
      numeroVagas: [
        {label: '0', value: '0'},
        {label: '1', value: '1'},
        {label: '2', value: '2'},
        {label: '3', value: '3'},
        {label: '4', value: '4'},
        {label: '5+', value: '5'}
      ],
    }
  },
  methods: {
    async cepClick() {
      await buscarCep(this.imovel.cep, this.imovel)
    },
    async fetchImovelEdit() {
      try {
        const response = await fetch(`${apiUrl.imoveis.retrieveUpdateDestroy(this.imovelKey)}?modo=edit`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: 'include',
        });

        if (!response.ok) {
          this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        }
        const data = await response.json();
        this.dado = data;
        normalizeDates(this.dado, ['data_previsao_entrega', 'habita_se', 'entrega_chaves',]);

      } catch (error) {
        this.erro = error.message;
      }
    },
    async submitIncluirForm() {
      try {
        const form = new FormData();
        denormalizeDates(this.dado, ['data_previsao_entrega', 'habita_se', 'entrega_chaves',]);
        for (const [key, value] of Object.entries(this.dado)) {
          form.append(key, value || "");
        }

        const response = await fetch(apiUrl.imoveis.retrieveUpdateDestroy(this.imovelKey), {
          method: "PATCH",
          credentials: 'include',
          body: form,
        });

        if (!response.ok) {
          const errorData = await response.json();
          this.campoVazio = Object.keys(errorData);
          if (errorData && typeof errorData === "object") {
            for (const campo in errorData) {
              errorData[campo].forEach(msg => {
                this.$toastMessage("error", campo, msg);
              });
            }
          } else {
            this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
          }
        } else {
          const imovelAtualizado = await response.json();
          this.$emit('atualizarImovel', imovelAtualizado);
          this.$toastMessage("success", "Registro alterado com sucesso!");
          this.$emit('fechar')
        }
      } catch (error) {
        this.$toastMessage("warn", "Atenção", "Erro ao editar registro!");
        console.log(error)
      }
    },
  },
  mounted() {
    this.fetchImovelEdit();
    Inputmask("99/99/9999").mask(this.$refs.previsaoEntrega.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.habitaSe.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.entregaChaves.$el.querySelector("input"));
  },
}
</script>